// =============================================================================
// locationSites.js — which institution a location sits at, and is it a theatre
// =============================================================================
// Both are what the clinic's drawer says: its Site and its Location type. A
// clinic with neither set has no site and is not a theatre (Oct 2026: both
// used to be guessed from text in the clinic's NAME). Mirrors
// src/logic/sites.py and the Excel export's split.
// =============================================================================
import { INSTITUTIONS } from './staffFields';

/** The location's institution (by id), or null. */
export const siteOf = (location, schedule) => {
  const sites = schedule?.locationSites || schedule?.location_sites || {};
  return INSTITUTIONS.includes(sites[location]) ? sites[location] : null;
};

/** Whether the location (by id) is a theatre: its type is OT. */
export const isTheatre = (location, schedule) => {
  const types = schedule?.locationTypes || schedule?.location_types || {};
  return types[location] === 'OT';
};
